// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

:root {
  --primary-hue: 240;
  --black-lightness: 15%;
  --dark-lightness: 44%;
  --light-lightness: 94%;
  --white-lightness: 100%;
  --color-primary: hsl(var(--primary-hue), 100%, 20%);
  --color-white: hsl(0, 5%, var(--white-lightness));
  --color-light: hsl(var(--primary-hue), 5%, var(--light-lightness));
  --color-black: hsl(var(primary-hue), 5%, var(--black-lightness));
  --color-dark: hsl(var(--primary-hue), 5%, var(--dark-lightness));

  /* General container variables */
  --container-width-lg: 76%;
  --container-width-md: 90%;

  /* Border radius variables */
  --border-radius-1: 1.2rem;
  --border-radius-2: 0.8rem;
  --border-radius-3: 0.5rem;

  /* General trasition variable */
  --transition: all 500ms ease;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden; /* Empêche le débordement horizontal global */
}

body {
  font-family: "Montserrat", sans-serif;
  line-height: 1.6;
  font-size: 0.9rem;
  overflow-x: hidden; /* Empêche le débordement horizontal */
}

/* Theme change using React context */
main.color-1 {
  --primary-hue: 240;
}

main.color-2 {
  --primary-hue: 110;
}

main.color-3 {
  --primary-hue: 240;
}

main.color-4 {
  --primary-hue: 325;
}

main.color-5 {
  --primary-hue: 0;
}

main.color-6 {
  --primary-hue: 55;
}

main.bg-2 {
  --black-lightness: 96%;
  --dark-lightness: 60%;
  --light-lightness: 12%;
  --white-lightness: 6%;
  --color-white: hsl(0, 5%, var(--white-lightness));
  --color-light: hsl(var(--primary-hue), 5%, var(--light-lightness));
  --color-black: hsl(var(--primary-hue), 5%, var(--black-lightness));
  --color-dark: hsl(var(--primary-hue), 5%, var(--dark-lightness));
}

main {
  color: var(--color-dark);
  --color-primary: hsl(var(--primary-hue), 100%, 20%);
}

/* General container class */
.container {
  width: var(--container-width-lg);
  margin-inline: auto;
  max-width: 1920px;
}

/* General section style */
section {
  padding: 10rem 0;
  background: var(--color-light);
  transition: var(--transition);
}

section:nth-child(even) {
  background: var(--color-white);
}

section > h2 {
  text-align: center;
}

section > p {
  text-align: center;
  margin: 0.5rem auto 4rem;
  width: 40%;
}

a {
  /* color: var(--color-white); */
  transition: var(--transition);
}

/* General heading styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  line-height: 1.1;
  color: var(--color-black);
}

h1 {
  font-size: 3rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.6rem;
}

h4 {
  font-size: 1.1rem;
}

h5 {
  font-size: 0.80rem;
}

h6 {
  font-size: 0.8rem;
}

/* General images styles */
img {
  display: block;
  width: 100%;
  object-fit: cover;
}

/* General button styles */
.btn {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 1rem;
  background: var(--color-light);
  color: var(--color-black);
  padding: 0.6rem 2.5rem;
  border: 2px solid transparent;
  border-radius: var(--border-radius-2);
  cursor: pointer;
}

.btn:hover {
  background-color: transparent;
  border-color: var(--color-light);
  transform: translateY(-0.5rem);
}

.btn.white {
  background: var(--color-white);
}

.btn.white:hover {
  background: transparent;
  border-color: var(--color-white);
}

.btn.primary {
  background: var(--color-primary);
  /* Text color always white, so i didn't use variable.*/
  color: white;
}

.btn.primary:hover {
  background: transparent;
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.btn.sm {
  padding: 0.5rem 1.2rem;
}

/* Media queries tablets */
@media screen and (max-width: 1024px) {
  body {
    font-size: 1rem;
  }

  .container {
    width: var(--container-width-md);
  }

  section {
    padding: 8rem 0;
  }

  section > p {
    width: 72%;
    margin-bottom: 3rem;
  }

  h1 {
    font-size: 2rem;
  }
}

/* Media queries phones * */
@media screen and (max-width: 600px) {
  h1 {
    font-size: 2.4rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.4rem;
  }

  h4 {
    font-size: 1rem;
  }

  .btn {
    padding: 0.6rem 1.5rem;
  }

  section > p {
    width: var(--container-width-md);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,mDAAmD;EACnD,iDAAiD;EACjD,kEAAkE;EAClE,gEAAgE;EAChE,gEAAgE;;EAEhE,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;;EAEzB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,iDAAiD;EACjD,kEAAkE;EAClE,kEAAkE;EAClE,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;;;;;;EAME,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  list-style: none;\n  text-decoration: none;\n  box-sizing: border-box;\n}\n\n:root {\n  --primary-hue: 240;\n  --black-lightness: 15%;\n  --dark-lightness: 44%;\n  --light-lightness: 94%;\n  --white-lightness: 100%;\n  --color-primary: hsl(var(--primary-hue), 100%, 20%);\n  --color-white: hsl(0, 5%, var(--white-lightness));\n  --color-light: hsl(var(--primary-hue), 5%, var(--light-lightness));\n  --color-black: hsl(var(primary-hue), 5%, var(--black-lightness));\n  --color-dark: hsl(var(--primary-hue), 5%, var(--dark-lightness));\n\n  /* General container variables */\n  --container-width-lg: 76%;\n  --container-width-md: 90%;\n\n  /* Border radius variables */\n  --border-radius-1: 1.2rem;\n  --border-radius-2: 0.8rem;\n  --border-radius-3: 0.5rem;\n\n  /* General trasition variable */\n  --transition: all 500ms ease;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  overflow-x: hidden; /* Empêche le débordement horizontal global */\n}\n\nbody {\n  font-family: \"Montserrat\", sans-serif;\n  line-height: 1.6;\n  font-size: 0.9rem;\n  overflow-x: hidden; /* Empêche le débordement horizontal */\n}\n\n/* Theme change using React context */\nmain.color-1 {\n  --primary-hue: 240;\n}\n\nmain.color-2 {\n  --primary-hue: 110;\n}\n\nmain.color-3 {\n  --primary-hue: 240;\n}\n\nmain.color-4 {\n  --primary-hue: 325;\n}\n\nmain.color-5 {\n  --primary-hue: 0;\n}\n\nmain.color-6 {\n  --primary-hue: 55;\n}\n\nmain.bg-2 {\n  --black-lightness: 96%;\n  --dark-lightness: 60%;\n  --light-lightness: 12%;\n  --white-lightness: 6%;\n  --color-white: hsl(0, 5%, var(--white-lightness));\n  --color-light: hsl(var(--primary-hue), 5%, var(--light-lightness));\n  --color-black: hsl(var(--primary-hue), 5%, var(--black-lightness));\n  --color-dark: hsl(var(--primary-hue), 5%, var(--dark-lightness));\n}\n\nmain {\n  color: var(--color-dark);\n  --color-primary: hsl(var(--primary-hue), 100%, 20%);\n}\n\n/* General container class */\n.container {\n  width: var(--container-width-lg);\n  margin-inline: auto;\n  max-width: 1920px;\n}\n\n/* General section style */\nsection {\n  padding: 10rem 0;\n  background: var(--color-light);\n  transition: var(--transition);\n}\n\nsection:nth-child(even) {\n  background: var(--color-white);\n}\n\nsection > h2 {\n  text-align: center;\n}\n\nsection > p {\n  text-align: center;\n  margin: 0.5rem auto 4rem;\n  width: 40%;\n}\n\na {\n  /* color: var(--color-white); */\n  transition: var(--transition);\n}\n\n/* General heading styles */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  line-height: 1.1;\n  color: var(--color-black);\n}\n\nh1 {\n  font-size: 3rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.6rem;\n}\n\nh4 {\n  font-size: 1.1rem;\n}\n\nh5 {\n  font-size: 0.80rem;\n}\n\nh6 {\n  font-size: 0.8rem;\n}\n\n/* General images styles */\nimg {\n  display: block;\n  width: 100%;\n  object-fit: cover;\n}\n\n/* General button styles */\n.btn {\n  display: inline-block;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  background: var(--color-light);\n  color: var(--color-black);\n  padding: 0.6rem 2.5rem;\n  border: 2px solid transparent;\n  border-radius: var(--border-radius-2);\n  cursor: pointer;\n}\n\n.btn:hover {\n  background-color: transparent;\n  border-color: var(--color-light);\n  transform: translateY(-0.5rem);\n}\n\n.btn.white {\n  background: var(--color-white);\n}\n\n.btn.white:hover {\n  background: transparent;\n  border-color: var(--color-white);\n}\n\n.btn.primary {\n  background: var(--color-primary);\n  /* Text color always white, so i didn't use variable.*/\n  color: white;\n}\n\n.btn.primary:hover {\n  background: transparent;\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n.btn.sm {\n  padding: 0.5rem 1.2rem;\n}\n\n/* Media queries tablets */\n@media screen and (max-width: 1024px) {\n  body {\n    font-size: 1rem;\n  }\n\n  .container {\n    width: var(--container-width-md);\n  }\n\n  section {\n    padding: 8rem 0;\n  }\n\n  section > p {\n    width: 72%;\n    margin-bottom: 3rem;\n  }\n\n  h1 {\n    font-size: 2rem;\n  }\n}\n\n/* Media queries phones * */\n@media screen and (max-width: 600px) {\n  h1 {\n    font-size: 2.4rem;\n  }\n\n  h2 {\n    font-size: 1.8rem;\n  }\n\n  h3 {\n    font-size: 1.4rem;\n  }\n\n  h4 {\n    font-size: 1rem;\n  }\n\n  .btn {\n    padding: 0.6rem 1.5rem;\n  }\n\n  section > p {\n    width: var(--container-width-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
